import { http, createConfig } from 'wagmi'
import {
  mainnet,
  pulsechain,
  // polygon, bsc, arbitrum, optimism
} from 'wagmi/chains'
import { injected } from 'wagmi/connectors'

/**
 * Chains supported by the app.
 * - mainnet: EIP-712 signatures for address generation and admin operations.
 * - pulsechain: on-chain registration and anchor publication via the
 *   ProjectIdRegistry contract (D-S6-6 / D-S6-7). mainnet is listed first so
 *   wallets default to Ethereum; pulsechain is only needed for the registry step.
 */
export const chains = [
  mainnet,
  pulsechain,
  // polygon, bsc, arbitrum, optimism,
] as const

export const config = createConfig({
  chains,
  connectors: [
    injected(),
    // walletConnect({ projectId: 'your-project-id' }),
    // coinbaseWallet({ appName: 'Sacrifice Dashboard' }),
  ],
  transports: {
    [mainnet.id]: http(),
    [pulsechain.id]: http(),
    // [polygon.id]: http(),
    // [bsc.id]: http(),
    // [arbitrum.id]: http(),
    // [optimism.id]: http(),
  },
})
